import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
 
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { GridColDef } from '@mui/x-data-grid';
 
import SearchField from '../../common/searchField';
import DataTable from '../../components/DataTable';
 
import { connectivityDashboardActions } from '../../store/reducers/connectivity-dashboard';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../utils/table-utils';
import { AssetsHistoryRequestPayloadTypes } from '../../store/models/connectivity-dashboard';
 
import { Grid, IconButton, lighten, useTheme } from '@mui/material';
import { useLocation, useOutletContext, useParams } from 'react-router-dom';
import { pageActions } from '../../store/reducers/page-actions';
import { get, isEmpty } from 'lodash';
import { palette } from '../../theme/palette';
import { ReactComponent as ViewIcon } from '../../assets/icons/main/eye-icon.svg';
 
import './connectivity.css';
import { ReactComponent as PlcConnected } from '../../assets/connectivitydashboard/plc-connected-icon.svg';
import { ReactComponent as PlcDisconnected } from '../../assets/connectivitydashboard/plc-disconnected-icon.svg';
import { ReactComponent as ConnectedIcon } from '../../assets/connectivitydashboard/connection-check-icon.svg';
import { ReactComponent as DisconnectedIcon } from '../../assets/connectivitydashboard/connection-remove-icon.svg';
import { ReactComponent as DataConnected } from '../../assets/connectivitydashboard/database-check-icon.svg';
import { ReactComponent as DataDisconnected } from '../../assets/connectivitydashboard/database-remove-icon.svg';
import LatestMessagePopup from './latestMessagePopup';
import { ontologyMasterActions } from '../../store/reducers/ontology-master';
import { convertUTCtoLocal } from '../../utils/time-converter';
import { ReactComponent as VrLineIcon } from '../../assets/icons/main/verticalLine.svg';
import { ReactComponent as EmqxConnectedIcon } from '../../assets/connectivitydashboard/emqx-connected-icon.svg';
import { ReactComponent as EmqxDisconnectedIcon } from '../../assets/connectivitydashboard/emqx-disconnected-icon.svg';
 
const Styles = {
  container: { boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.02)', borderRadius: '18px' },
  paper: {
    margin: 'auto',
    boxShadow: '0px 0px 14px 0px #0000000D',
    borderRadius: '18px',
    border: `1px solid #D9DFED`,
    // height: '83vh',
    overflow: 'hidden',
  },
  header: {
    p: 3,
    display: 'flex',
    justifyContent: 'flex-end',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    boxSizing: 'border-box',
    alignItem: 'center',
    // height: '87px',
  },
  searchFieldWrapper: { display: 'flex', alignItems: 'center', columnGap: 3, width: '80%' },
  dataTableWrapper: {
    height: '100%',
    overflow: 'hidden',
  },
  dataTable: {
    '& .MuiDataGrid-virtualScroller': {
      overflow: 'auto',
      overflowY: 'hidden',
      minHeight: 'calc(100vh - 420px)',
      paddingBottom: '10px',
      height: '100%',
    },
    '&.MuiDataGrid-root': {
      // height:'100%',
      minHeight: 'calc(100vh - 278px)',
    },
    '.MuiDataGrid-iconButtonContainer': {
      visibility: 'visible',
    },
    '.MuiDataGrid-sortIcon': {
      opacity: 'inherit !important',
    },
    '.data-table-row-even': {
      backgroundColor: '#F8FAFB',
    },
    '.data-table-row-odd': {
      backgroundColor: '#FFFFFF',
    },
    '.MuiDataGrid-cellContent': {
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '400',
      color: '#64759F',
    },
    '.MuiDataGrid-cell': {
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '400',
      color: '#64759F',
    },
    '.MuiDataGrid-columnHeader:first-child': {
      paddingLeft: '24px',
    },
    '.MuiDataGrid-columnHeader:last-child': {
      paddingRight: '24px !important',
    },
    '.MuiDataGrid-cell:first-child': {
      paddingLeft: '24px',
      paddingRight: '24px',
    },
    '.MuiDataGrid-cell:nth-last-child(2)': {
      paddingRight: '24px',
    },
  },
  closeBtnWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBlock: 4,
    borderTop: '1px solid #D9DFED',
  },
  tableCellText: {
    fontSize: '16px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  messageModal: {
    container: { boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.02)', borderRadius: '18px' },
    paper: {
      margin: 'auto',
      boxShadow: '0px 0px 14px 0px #0000000D',
      borderRadius: '18px',
      border: `1px solid #D9DFED`,
 
      overflow: 'hidden',
    },
    header: {
      p: 3,
      display: 'flex',
      justifyContent: 'flex-end',
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      boxSizing: 'border-box',
      // height: '87px',
    },
    searchFieldWrapper: { display: 'flex', alignItems: 'center', columnGap: 3 },
    dataTableWrapper: {
      height: '100%',
      overflow: 'hidden',
      padding: '24px',
      radius: '18px',
    },
    dataTable: {
      '& .MuiDataGrid-virtualScroller': {
        overflow: 'auto',
      },
      '&.MuiDataGrid-root': {
        height: 'calc(80vh - 196px)',
        minHeight: 'calc(80vh - 196px)',
      },
    },
    closeBtnWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBlock: 4,
      marginTop: '24px',
    },
    tableCellText: {
      fontSize: '16px',
      fontWeight: 400,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  },
  connectedIcon: { paddingLeft: '8px' },
  disConnectedIcon: { cursor: 'pointer', paddingLeft: '8px' },
};
 
interface AssetsLabelTypes {
  all: string;
  connected: string;
  disconnected: string;
}
 
const assetsLabel: AssetsLabelTypes = {
  all: '',
  connected: 'CONNECTED',
  disconnected: 'DISCONNECTED',
};
 
const AssetsHistory = ({
  onModalClose,
  assetsHistoryData,
  assetsHistoryLoading,
  assetHistoryPageNumber,
  assetHistoryTotalCount,
  assetsHistoryRequestFailed,
  ontologyData,
  ontologies,
}: any) => {
  const theme = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});
  const dispatch = useDispatch();
  const [sortingModel, setSortingModel] = useState({ field: '', sort: '' });
  const [searchValue, setSearchValue] = useState('');
  const [assetData, setAssetData] = useState<any>([]);
  const { pathname } = useLocation();
  const { asset_id, type, onto_manage_id } = useParams();
  const [singleAsset, setSingleAsset] = useState<any>({});
  const [popupMsgData, setPopupMsgData] = useState<any>({ status: false, type: '', item: {}, connectivityStatus: '' });
 
  const dispatchAssetsHistoryRequest = (payload: AssetsHistoryRequestPayloadTypes) => {
    const id: any = asset_id;
    dispatch(
      connectivityDashboardActions.getAssetsHistoryDataRequest({
        ...sortingModel,
        search_item: searchValue,
        ...payload,
        component_id: id,
        timestamp: new Date().getTime(),
      })
    );
  };
 
  const onSearch = (value: string) => {
    dispatchAssetsHistoryRequest({
      limit: DEFAULT_PAGE_SIZE,
      page: DEFAULT_PAGE_NUMBER,
      search_item: value,
    });
    setSearchValue(value);
  };
 
  useEffect(() => {
    const data: any = [
      {
        route: 'connectivity-dashboard',
        pathName: 'Connectivity Dashboard',
        navigate: true,
      },
      {
        route: '',
        pathName: 'Assets History',
        navigate: false,
      },
      {
        route: '',
        pathName: '',
        navigate: false,
      },
    ];
    dispatch(pageActions.setPagePath(data));
 
    dispatchAssetsHistoryRequest({ limit: DEFAULT_PAGE_SIZE, page: DEFAULT_PAGE_NUMBER });
 
    dispatch(ontologyMasterActions.getOntologyList(''));
    dispatch(ontologyMasterActions.getOntologyMgmntList(''));
 
    return () => {
      dispatch(connectivityDashboardActions.resetAssetsHistoryTable());
    };
  }, [asset_id, pathname]);
 
  const getOntologyData = (ontoId: any) => {
    if (ontologies.length > 0) {
      let tempOntoData: any = [];
      restartTheLoop: while (true) {
        for (const item of ontologies) {
          if (item.onto_manage_id == ontoId) {
            tempOntoData.unshift(item);
            ontoId = item.parent_id;
            continue restartTheLoop;
          }
        }
        break;
      }
 
      tempOntoData.map((item: any) => {
        let getLevelName = ontologyData.filter((data: any) => {
          return data.id === item.onto_level_number;
        })[0];
 
        return {
          ...item,
          level_name: getLevelName?.level_name || '',
        };
      });
 
      return tempOntoData;
    }
    return [];
  };
 
  useEffect(() => {
    if (!isEmpty(assetsHistoryData) && !isEmpty(ontologies)) {
      const _singleAsset = get(assetsHistoryData, 'asset', {});
      if (_singleAsset.onto_manage_id) {
        const _ontologyList = getOntologyData(_singleAsset.onto_manage_id);
        setSingleAsset({ ..._singleAsset, ontologyList: _ontologyList });
      } else {
        setSingleAsset(_singleAsset);
      }
 
      if (assetsHistoryData.data.length) {
        setAssetData(
          assetsHistoryData.data.map((item: any, index: number) => {
            return { ...item, id: index + 1 };
          })
        );
      } else {
        setAssetData([]);
      }
    }
  }, [assetsHistoryData, ontologies]);
 
  useEffect(() => {
    if (pathname.length) {
      const pathnamesTemp: any = pathname.split('/').filter(Boolean);
      if (pathnamesTemp.length) {
        const pathnamesData: any = pathnamesTemp
          .filter((i: any, index: number) => index === 0 || index === 1)
          .map((item: any, index: number) => {
            if (index == 0) {
              return { route: pathnamesTemp[0], pathName: item.replace('-', ' '), navigate: true };
            } else if (index == 1) {
              if (item === 'assets') {
                return {
                  route: pathnamesTemp[0] + '/' + pathnamesTemp[1] + '/' + onto_manage_id + '/' + type,
                  pathName: item,
                  navigate: true,
                };
              } else {
                return { route: '', pathName: 'Asset History', navigate: false };
              }
            } else {
              return { route: '', pathName: assetData.length ? assetData[0]['asset_name'] : '', navigate: false };
            }
          });
 
        dispatch(pageActions.setPagePath(pathnamesData));
        return () => {
          const data: any = [];
          dispatch(pageActions.setPagePath(data));
        };
      }
    } else {
      const data: any = { route: '', pathName: '', navigate: false };
      dispatch(pageActions.setPagePath(data));
    }
  }, [assetData]);
 
  // Polling
  useEffect(() => {
    let interval: any;
    if (!assetsHistoryLoading) {
      interval = setInterval(() => {
        dispatch(
          connectivityDashboardActions.getAssetsHistoryPollingDataRequest({
            ...sortingModel,
            search_item: searchValue,
            component_id: asset_id,
            limit: DEFAULT_PAGE_SIZE,
            page: assetHistoryPageNumber,
            timestamp: new Date().getTime(),
          })
        );
      }, 60000);
    }
 
    return () => {
      clearInterval(interval);
    };
  }, [sortingModel, searchValue, assetsHistoryLoading]);
 
  // function dateFormat(value: any) {
  //   if (value && value != '') {
  //     const currentDate = new Date(value);
  //     const formattedDate = currentDate.toLocaleDateString('en-US', {
  //       day: 'numeric',
  //       month: 'long',
  //       year: 'numeric',
  //       hour: 'numeric',
  //       minute: 'numeric',
  //       second: '2-digit',
  //     });
  //     return formattedDate;
  //   } else {
  //     return '';
  //   }
  // }
 
  const columns: GridColDef[] = [
    {
      field: 'gateway',
      headerName: 'Gateway',
      headerAlign: 'left',
      align: 'left',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'timestamp',
      headerName: 'Time',
      headerAlign: 'left',
      align: 'left',
      minWidth: 250,
      flex: 1,
      renderCell: (params: any) => {
        const lastConnected = convertUTCtoLocal(params.value);
        return (
          <Tooltip title={lastConnected} arrow>
            <Typography component='p' sx={Styles.tableCellText} color={theme.palette.text.primary}>
              {lastConnected}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'message',
      headerName: 'Message',
      headerAlign: 'left',
      align: 'left',
      minWidth: 500,
      flex: 1,
      renderCell: (params: any) => {
        return <Box sx={{ textWrap: 'wrap', width: '800px' }}>{params.value}</Box>;
      },
    },
    {
      field: 'message_type',
      headerName: 'Message type',
      headerAlign: 'left',
      align: 'left',
      minWidth: 200,
    },
    {
      field: 'asset_id',
      headerName: 'MQTT Message',
      // flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      renderCell: (params) => {
        return (
          <IconButton onClick={() => handleLogsPopupOpen('MQTT', get(params, 'row', {}))}>
            <ViewIcon style={{ color: theme.palette.text.primary }} />
          </IconButton>
        );
      },
      minWidth: 180,
    },
  ];
 
  const handleLogsPopupOpen = (type: any, item: any) => {
    setPopupMsgData({ status: true, title: 'MQTT MESSAGE', type: type, item: JSON.parse(get(item, 'logs', '{}')) });
  };
  const handleLogsPopupClose = () => {
    setPopupMsgData({ status: false, title: '', type: '', item: {} });
  };
 
  const handleMessagePopupOpen = (title: string, type: any, item: any) => {
    setPopupMsgData({ status: true, title: title, type: type, item: item?.latest_message });
  };
 
  const connectedIconStyle = { ...Styles.connectedIcon, color: theme.palette.success.main };
  const disconnectedIconStyle = { ...Styles.disConnectedIcon, color: theme.palette.error.main };
 
  return (
    <Container maxWidth={false} disableGutters sx={Styles.container}>
      <Paper
        sx={{
          ...Styles.paper,
          border: `1px solid  ${theme.palette.customBorderColor.main}`,
          backgroundColor: themeMode.isLightBG
            ? lighten(theme.palette.background.default, 0.9)
            : lighten(theme.palette.background.default, 0.05),
        }}
      >
        <Box sx={Styles.header}>
          <Grid container columnSpacing={1} rowGap={2}>
            <Grid
              lg={7}
              xl={7}
              md={7}
              sm={12}
              display='flex'
              alignItems='center'
              flexWrap='wrap'
              columnGap={8}
              rowGap={2}
            >
              <Typography
                sx={{ color: theme.palette.text.primary, fontSize: '16px', fontWeight: '400', textWrap: 'nowrap' }}
              >
                Asset IP : <b>{get(singleAsset, 'asset_ip', '')}</b>
              </Typography>
              <Typography
                sx={{ color: theme.palette.text.primary, fontSize: '16px', fontWeight: '400', textWrap: 'nowrap' }}
              >
                Asset Name : <b>{get(singleAsset, 'asset_name', '')}</b>
              </Typography>
              <Typography
                sx={{
                  color: theme.palette.text.primary,
                  fontSize: '16px',
                  fontWeight: '400',
                  textWrap: 'nowrap',
                }}
              >
                Location :{' '}
                <b>
                  {singleAsset.ontologyList && singleAsset.ontologyList.length
                    ? singleAsset.ontologyList.map((item: any, index: number) =>
                        singleAsset.ontologyList.length > 1 ? (
                          index === singleAsset.ontologyList.length - 1 ? (
                            <span key={item.onto_manage_title}>{item.onto_manage_title} </span>
                          ) : (
                            <span key={item.onto_manage_title}>{item.onto_manage_title} / </span>
                          )
                        ) : (
                          <span key={item.onto_manage_title}>{item.onto_manage_title}</span>
                        )
                      )
                    : ''}
                </b>
              </Typography>
            </Grid>
            <Grid
              lg={5}
              xl={5}
              md={5}
              sm={12}
              sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: 2 }}
            >
              <Grid container rowGap={2}>
                <Grid item xs={5} md={12} lg={5} display='flex' alignItems='center'>
                  <span style={{ marginRight: '21px' }}>Status : </span>
                  {singleAsset.connectivity_status === 'connected' ? (
                    <EmqxConnectedIcon style={{ ...connectedIconStyle, paddingLeft: 0 }} />
                  ) : (
                    <EmqxDisconnectedIcon
                      style={{ ...disconnectedIconStyle, padding: 0 }}
                      onClick={() => handleMessagePopupOpen('MQTT Broker Connection', 'Disonnected', singleAsset)}
                    />
                  )}
                  {singleAsset.plc_status === 'connected' ? (
                    <PlcConnected style={connectedIconStyle} />
                  ) : (
                    <PlcDisconnected
                      style={disconnectedIconStyle}
                      onClick={() => handleMessagePopupOpen('PLC Server Connection', 'Disconnected', singleAsset)}
                    />
                  )}
                  {singleAsset.data_status === 'connected' ? (
                    <DataConnected style={connectedIconStyle} />
                  ) : (
                    <DataDisconnected
                      style={disconnectedIconStyle}
                      onClick={() => handleMessagePopupOpen('Data Server Connection', 'Disconnected', singleAsset)}
                    />
                  )}
                </Grid>
                <Grid item xs={7} md={12} lg={7} display='flex' justifyContent='flex-end'>
                  <Box sx={Styles.searchFieldWrapper}>
                    <VrLineIcon style={{ color: theme.palette.customBorderColor.main }} />
                    <SearchField searchPlaceholder='Search' onSearch={onSearch} sx={{ width: '100%' }} />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box sx={Styles.dataTableWrapper}>
          <DataTable
            columns={columns}
            rows={assetData}
            loading={assetsHistoryLoading}
            tableStyles={Styles.dataTable}
            noRowsOverlay={() => (
              <Stack height='100%' alignItems='center' justifyContent='center'>
                Assets History Not Available
              </Stack>
            )}
            isServerPagination
            totalRowCount={assetHistoryTotalCount}
            pageNumber={assetHistoryPageNumber}
            onPagination={(pageSize: number, pageNumber: number) => {
              dispatchAssetsHistoryRequest({
                limit: pageSize,
                page: pageNumber,
              });
            }}
            onSorting={(sortModel: { field: string; sort: string }) => {
              dispatchAssetsHistoryRequest({
                limit: DEFAULT_PAGE_SIZE,
                page: assetHistoryPageNumber,
                ...sortModel,
              });
              setSortingModel(sortModel);
            }}
            otherProps={{
              getRowId: (row: any) => row.id,
            }}
          />
        </Box>
      </Paper>
      {popupMsgData.status && (
        <LatestMessagePopup popupMsgData={popupMsgData} handleMsgPopupClose={handleLogsPopupClose} />
      )}
    </Container>
  );
};
 
const mapStateToProps = (state: any) => ({
  assetsHistoryData: state.connectivityDashboard.assetsHistoryData,
  assetsHistoryLoading: state.connectivityDashboard.assetsHistoryLoading,
  assetHistoryPageNumber: state.connectivityDashboard.assetHistoryPageNumber,
  assetHistoryTotalCount: state.connectivityDashboard.assetHistoryTotalCount,
  assetsHistoryRequestFailed: state.connectivityDashboard.assetsHistoryRequestFailed,
  ontologyData: state.ontologyMaster.ontologyData,
  ontologies: state.ontologyMaster.ontologyMgmntData,
});
 
export default connect(mapStateToProps)(AssetsHistory); 
 